export default __webpack_public_path__ + "static/media/030-Tuk tuk.1085529b.svg";